import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import classnames from 'classnames'
import { renderRoutes, matchRoutes } from 'react-router-config'

import { generatePageDataFromPathname } from '../../utils/wordpress'

import { requestWpPageDataSuccess } from '../../reducers/wpData'

import Header from '../components/Header'
import Modal from '../components/modals/Modal'
import CookiesAndAnalyticsInfo from '../components/CookiesAndAnalyticsInfo'

class App extends Component {
  render () {
    const { pageData, route } = this.props

    let headerContent = <Header />

    const classes = classnames({
      [/page/.test(pageData.slug)
        ? pageData.slug
        : `page--${pageData.slug}`]: true
    })

    return (
      <div className={classes}>
        {headerContent}

        {renderRoutes(route.routes)}

        <Modal />

        <CookiesAndAnalyticsInfo />
      </div>
    )
  }
}

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  route: PropTypes.shape({
    routes: PropTypes.array.isRequired
  }).isRequired,
  requestWpPageDataSuccess: PropTypes.func.isRequired
}

function mapStateToProps ({ wpData: { pages } }, ownProps) {
  // here we dont have access to the matched route; since we are above them
  // renderRoutes call, inside App.render.
  const matchedRoutes = matchRoutes(
    ownProps.route.routes,
    ownProps.location.pathname
  )
  const matchedRoute = matchedRoutes && matchedRoutes[0].route
  const wpPageId = matchedRoute && matchedRoute.wpPageId

  const cachedPageData = pages[wpPageId]
  return {
    wpPageId,
    pageDataFromCache: !!cachedPageData,
    // if we don't have cached wp data for this page (some pages aren't on wp at all),
    // still provide some generic page data, so pages can rely on it (title etc)
    pageData:
      cachedPageData || generatePageDataFromPathname(ownProps.location.pathname)
  }
}

export default connect(
  mapStateToProps,
  {
    requestWpPageDataSuccess
  }
)(App)
